<div class="md-container">
    <h3 class="lb-title-modal">Selecciona tu provincia</h3>
    <p-table
        [value]="lsProvincia"
        [rows]="4"
        styleClass="font-size: 10px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        selectionMode="single" 
    >
        <ng-template pTemplate="header" let-columns>
            <tr class="header-table">
            </tr>
            <tr>
                <th scope="col" [hidden]="true">

                </th>
                <th *ngIf="!loading" scope="col">
                    <p-columnfilter 
                        class="filter-modal in-center"
                        type="text" 
                        field="Nombre"
                        placeholder="Buscar provincia"
                        matchMode="contains"
                        [showMenu]="false" 
                    ></p-columnfilter>
                </th>
                <p-skeleton *ngIf="loading" height="1rem" styleClass="mb-2 sheleton-header-2"></p-skeleton>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dataProvincia let-rowIndex="rowIndex">
            <tr style="cursor: pointer;" [pSelectableRow]="dataProvincia" (click)="onRowDblClick($event, dataProvincia)">
                <td [hidden] = "true">
                    {{dataProvincia.Id}}
                </td>
                <td class="center">
                    {{dataProvincia.Nombre | uppercase}}
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr *ngIf="!loading">
                <td colspan="3">No existen registros.</td>
            </tr>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton *ngIf="loading" height="3rem" styleClass="mb-2"></p-skeleton>
        </ng-template>
    </p-table>
</div>